import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogEncomenda = ({ initial, onClose, ...props }) => {
    const validationSchema = yup.object({
        codigo: yup.string().required('O campo é obrigatório'),
        compra: yup.string().nullable(),
        designacao: yup.string().required('O campo é obrigatório'),
        fornecedor: yup.string().required('O campo é obrigatório'),
        quantidade: yup.number().required('O campo é obrigatório'),
        prazo: yup
            .number()
            .min(0, 'O valor não pode ser menor que 0')
            .when('compra', {
            is: value => {
                return value != undefined;
            }, // se o agendamento não for cancelado o preenchimento é obrigatório
            then: schema => schema.required('O campo é obrigatório'),
            otherwise: schema => schema.nullable()
        }),
        preco: yup.number().min(0, 'O valor não pode ser menor que 0').required('O campo é obrigatório'),
        encomendado: yup.boolean().default(false)
    });
    const formik = useFormik({
        initialValues: initial,
        validationSchema: validationSchema,
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    console.log('formik', formik);
    // Formik fix dialog reuse
    useEffect(() => {
        formik.resetForm();
        formik.setValues(initial ?? {});
    }, [initial]);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Encomenda</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={3} md={4} xs={12}>
              <TextField label='Cód. Artigo *' name='codigo' defaultValue={formik.values?.codigo} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.codigo && Boolean(formik.errors.codigo)} helperText={formik.touched.codigo && formik.errors.codigo}/>
            </Grid>
            <Grid lg={9} md={8} xs={12}>
              <TextField label='Fornecedor *' name='fornecedor' value={formik.values?.fornecedor} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.fornecedor && Boolean(formik.errors.fornecedor)} helperText={formik.touched.fornecedor && formik.errors.fornecedor}/>
            </Grid>
            <Grid lg={8} md={8} xs={8}>
              <TextField label='Designação *' name='designacao' defaultValue={formik.values?.designacao} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.designacao && Boolean(formik.errors.designacao)} helperText={formik.touched.designacao && formik.errors.designacao}/>
            </Grid>
            <Grid lg={4} md={4} xs={4}>
              <TextField label='Quantidade *' type='number' name='quantidade' value={formik.values?.quantidade} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.quantidade && Boolean(formik.errors.quantidade)} helperText={formik.touched.quantidade && formik.errors.quantidade}/>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid lg={4} md={4} xs={4}>
              <TextField label='Cód. Compra *' name='compra' value={formik.values?.compra} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.compra && Boolean(formik.errors.compra)} helperText={formik.touched.compra && formik.errors.compra}/>
            </Grid>
            <Grid lg={4} md={4} xs={4}>
              <TextField label='Prazo' InputProps={{
            endAdornment: <InputAdornment position='end'>dias</InputAdornment>
        }} type='number' name='prazo' value={formik.values?.prazo} onChange={formik.handleChange} onBlur={formik.handleBlur} required={formik.values?.prazo != null} fullWidth error={formik.touched.prazo && Boolean(formik.errors.prazo)} helperText={formik.touched.prazo && formik.errors.prazo}/>
            </Grid>
            <Grid lg={4} md={4} xs={4}>
              <TextField label='Preço' InputProps={{
            endAdornment: <InputAdornment position='end'>€</InputAdornment>
        }} name='preco' type='number' value={formik.values?.preco} onChange={formik.handleChange} onBlur={formik.handleBlur} required fullWidth error={formik.touched.preco && Boolean(formik.errors.preco)} helperText={formik.touched.preco && formik.errors.preco}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogEncomenda;
